export const environment = {
  production: false,
  frontegg: {
    moduleConfig: {
      contextOptions: {
        baseUrl: 'https://login.softdocsdev.cloud',
        clientId: 'af19eb4a-0f2a-4de6-8f08-620ca3ac673c',
        appId: 'bff95bbe-e049-4985-a116-b9f23d0c381a'
      },
      hostedLoginBox: true,
      authOptions: { keepSessionAlive: true }
    }
  },
  printer: {
    // Frontegg application registered for the virtual printer. Empty until it exists in this environment.
    appId: '9f6376bc-ad49-4111-8866-d29c4fd34941',
    // The one loopback address the printer listens on. Never taken from a request.
    redirectUri: 'http://127.0.0.1:4400/callback'
  },
  urls: {
    addonScript:
      'https://script.google.com/macros/s/AKfycbz6BJVXaVcwrkfDiwrfF6NDjm4EGM_hOKhZTEI5a2V0qBQsUWhjLl96SlIw5WhQZy1p/exec',
    autoclassifierApi: 'https://svc.softdocsdev.cloud/capture',
    tenantApi: 'https://api.softdocsdev.cloud/tenant',
    transcriptApi: 'https://svc.softdocsdev.cloud/document-processor',
    modificationApi: 'https://svc.softdocsdev.cloud/document-modification',
    websocketApi: 'wss://svc.softdocsdev.cloud/websocket'
  },
  launchDarkly: {
    clientSideId: '64b69036d75e0613f8d7443c'
  },
  dynamsoft: {
    productKey:
      'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0NDkxNTE1LTEwNDUyMTQ5NSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21kbHMuZHluYW1zb2Z0b25saW5lLmNvbS8iLCJvcmdhbml6YXRpb25JRCI6MTA0NDkxNTE1LCJzdGFuZGJ5U2VydmVyVVJMIjoiaHR0cHM6Ly9zZGxzLmR5bmFtc29mdG9ubGluZS5jb20vIiwiY2hlY2tDb2RlIjotMTIxNTYyOTUzfQ==',
    resourcesPath: 'https://unpkg.com/dwt/dist/'
  }
};
